export default __webpack_public_path__ + "static/media/Make-a-Connection.faf3ec59.gif";